export default function EditorialMarquee() {
  const message = "GRAND OPENING / TECH VAULT IS OPEN // 0.10% OF PROCEEDS SUPPORTS TROOPS AFTER DEPLOYMENT // MIL-STD-810H CERTIFIED // SOURCE / VERIFY / DISPATCH // ZERO-FAIL COMMERCE //";
  return (
    <section className="marquee-band" data-testid="editorial-marquee">
      <div className="marquee-window">
        <div className="marquee-track"><span>{message}</span><span aria-hidden="true">{message}</span></div>
      </div>
    </section>
  );
}
